<template>
  <!--
  Example of use

    <card-custom
      class="d-inline"
      event_name="sysacq"
      :dropdown_state="false"
      :teaser_content="false"
      style="height: 100%;"
    >
      <template v-slot:prepend_icon>
        <icon icon="mdi:router-network-wireless" height="24px" color="grey" />
      </template>
      <template v-slot:title>
        <div class="text-subtitle-2">Système d'acquisition / Transfert de données</div>
      </template>
      <template v-slot:teaser>
        my teaser
      </template>
      <template v-slot:content>
        my content
      </template>
    </card-custom>

  <script>
    import CardCustom from "../components/UI_kit/CardCustom.vue"
    import { Icon } from '@iconify/vue2'

    export default {
      components: {
        CardCustom,
        Icon,
      },
  </script>
  -->

  <v-card class="mx-auto" v-bind="$attrs">
    <v-card-title class="custom-title">
      <!-- LEFT: prepend icon -->
      <div v-if="hasPrependIcon" class="left-icon">
        <slot name="prepend_icon" />
      </div>

      <!-- CENTER: title -->
      <div class="title-text">
        <slot name="title" />
      </div>

      <!-- RIGHT: dropdown icon (JUST NEXT TO TITLE) -->
      <div v-if="show_dropdown_state" class="dropdown-icon">
        <icon-dropdown
          :init_state="ddi_card_content_state"
          :event_name="event_name"
        />
      </div>
    </v-card-title>

    <v-divider v-if="ddi_card_content_state || hasTeaser" class="mx-3" />
    <v-card-text v-if="ddi_card_content_state || hasTeaser">
      <div :class="ddi_card_content_state ? (hasTeaser ? 'pb-4' : '') : ''">
        <slot name="teaser" v-if="hasTeaser" />
      </div>
      <v-divider
        v-if="ddi_card_content_state && hasTeaser && hasContent"
        class="pb-4"
      />
      <div v-if="ddi_card_content_state && hasContent">
        <slot name="content" />
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import eventBus from "../../store/event_bus";
import IconDropdown from "./IconDropdown.vue";
import event_bus from "../../store/event_bus";

export default {
  name: "CardCustom",
  components: {
    IconDropdown,
  },

  props: {
    show_dropdown_state: {
      type: Boolean,
      required: true,
      default: true,
    },

    dropdown_state: {
      type: Boolean,
      required: true,
      default: false,
    },

    event_name: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      ddi_card_content_state: this.dropdown_state,
    };
  },

  mounted() {
    eventBus.$on(`${this.event_name}`, () => {
      this.ddi_card_content_state = !this.ddi_card_content_state;
      // console.log(`${this.event_name}=${this.ddi_card_state}`)

      this.emitComponentMsg();
    });
  },

  beforeDestroy() {
    eventBus.$off(`${this.event_name}`);
  },

  watch: {},

  computed: {
    hasPrependIcon() {
      return !!this.$slots.prepend_icon;
    },
    hasTeaser() {
      return !!this.$slots.teaser;
    },
    hasContent() {
      return !!this.$slots.content;
    },
  },

  methods: {
    emitComponentMsg() {
      if (event_bus) {
        event_bus.$emit("card_custom", {
          component: this.event_name,
          state: this.ddi_card_content_state,
        });
      }
    },
  },
};
</script>

<style scoped >
.custom-title {
  display: inline-flex !important;
  align-items: center;
  width: auto !important;       /* <— Prevents full-width stretching */
  gap: 8px;                     /* Space between items */
  padding-left: 12px;
}

.left-icon {
  display: inline-flex;
  align-items: center;
}

.title-text {
  display: inline-flex;
  align-items: center;
}

.dropdown-icon {
  display: inline-flex;
  align-items: center;
  margin-left: 12px; 
}


</style>
